/**
 * Returns whether object is empty or not
 * @param {Object} obj Object to check
 * @returns {Boolean}
 */
export const isEmpty = (obj) => {
  for (var i in obj) return false;
  return true;
};

/**
 * Function to round numbers
 * @param {Number} value Number to round
 * @param {Number} precision rounding precision
 * @returns {Number} number rounded upto {value} decimal places
 */
export function round(value, precision = 1) {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

/**
 * Function to capitalize a string
 * @param {String} str Input string
 * @returns {String} Capitalized string
 */
export function toTitleCase(str) {
  if (typeof str !== "string") return str;
  return str?.replace(
    /\w\S*/g,
    (c) => c?.charAt(0)?.toUpperCase() + c?.substr(1)?.toLowerCase()
  );
}

/**
 * Function to return formatted current time
 * @returns {String} HH:MM:SS.MS
 */
export const strftime = () => {
  let time = new Date();
  return `${time.getHours().toString().padStart(2, 0)}:${time
    .getMinutes()
    .toString()
    .padStart(2, 0)}:${time.getSeconds().toString().padStart(2, 0)}:${time
    .getMilliseconds()
    .toString()
    .padStart(3, 0)}`;
};

/**
 * List of Months
 */
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 *
 * @param {String} string1
 * @param {String} string2
 * @returns {Boolean} compare string, case insensitive
 */
export const match = (string1, string2) =>
  Boolean(string1?.toLowerCase() === string2?.toLowerCase());

export const compareObj = (obj1, obj2) => {
  let obj1_arr = Object.keys(obj1 || []);
  let obj2_arr = Object.keys(obj2 || []);

  if (obj1_arr.length !== obj2_arr.length) return false;

  for (let key of obj1_arr) if (obj1[key] !== obj2[key]) return false;

  return true;
};

export const radians = (deg) => deg / 57.29577951;

export const calcDist = (lat1, long1, lat2, long2) =>
  6377.830272 *
  Math.acos(
    Math.sin(radians(lat1)) * Math.sin(radians(lat2)) +
      Math.cos(radians(lat1)) *
        Math.cos(radians(lat2)) *
        Math.cos(radians(long1) - radians(long2))
  );

export const mail_regex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
